import React from 'react';
import { Layout } from 'antd';

const { Footer: AntFooter } = Layout;

const Footer = () => {
  return (
    <AntFooter
      style={{
        textAlign: "center",
        padding: "10px 50px",
        background: "#ffffff",
        borderTop: "1px solid #f0f0f0"
      }}
    >
      <a href="https://clouddeveloper.in/">Powered by CloudDeveloper</a>
      <p>Created by <a href="https://btacode.com/">Raaj</a> with ❤️</p>
    </AntFooter>
  );
};

export default Footer;
